export type HandlerType = 'boundary' | 'snackbar';

export interface ResponseHandlerOptions {
  handlerType?: HandlerType;
  snackbarMsgId?: string;
}

export enum ErrorCode {
  Forbidden = 'FORBIDDEN',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  NotFound = 'NOT_FOUND',
  ConsentRequired = 'ERR_CONSENT_REQUIRED',
}

export class FormattedError extends Error {
  public readonly code: string;

  constructor(code: string, message: string, options?: ErrorOptions) {
    super(message, options);
    this.code = code;
  }
}
